import React, { useContext, Fragment, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import loadable from '@loadable/component';
import SlideInCard from '../SlideInCard';
import Modal from '../Modal';
import Animation from '../Animation';
import RoundButton from '../RoundButton';
import FullScreenLoader from '../FullScreenLoader';
import { Context } from '../../context/AppContext';
import { MODALS } from '../../constants';
import reviewSubmitted from '../../animations/reviewSubmitted.json';

const Form = loadable(() => import('./ReviewForm'), {
  fallback: <FullScreenLoader />,
});

const ReviewForm = ({ defaults = {} }) => {
  const { search } = useLocation();

  const modalName = MODALS.REVIEW_FORM;

  const {
    media: { mobile },
    modal: { showModal, modals },
    user: { userContactDetails },
  } = useContext(Context);

  const { data } = modals[modalName];
  const [slideInShow, setSlideInShow] = useState(false);

  const { disableDefaults } = data || {};

  useEffect(() => {
    const queryParams = queryString.parse(search);
    if (!queryParams.action) return;
    setSlideInShow(queryParams.action.includes('reviewSuccess'));
  }, [search]);

  return (
    <Fragment>
      <Modal
        name={modalName}
        onClickOutside={() => showModal(MODALS.MODAL_CONFIRMATION)}
      >
        <Form
          data={{
            ...(disableDefaults ? {} : defaults),
            ...data,
            ...userContactDetails,
          }}
          slideInShow={slideInShow}
          setSlideInShow={setSlideInShow}
        />
      </Modal>
      <SlideInCard
        show={slideInShow}
        title="Thanks for your review!"
        message="Keep an eye on your inbox over the next 1 to 2 business days to see
        when your review goes live."
        setShow={setSlideInShow}
        icon={
          <Animation
            animation={reviewSubmitted}
            loop={false}
            height={mobile ? 150 : 100}
            width={mobile ? 150 : 100}
          />
        }
      >
        <RoundButton
          onClick={() => setSlideInShow(false)}
          style={{ width: '110px' }}
          theme="outlineLightGrey"
        >
          Return
        </RoundButton>
      </SlideInCard>
    </Fragment>
  );
};

export default ReviewForm;
